import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LeadService {
    private leadsChangedSubject = new Subject<void>();
    leadsChanged$ = this.leadsChangedSubject.asObservable();

    constructor(private http: HttpClient) {}

    // Get Alert List
    getLeads(params: { page?: number; sortBy?: string; sortDir?: string } = {}) {
        const httpParams = this.buildLeadParams(params);
        return this.http.get<Array<Object>>(
            `${environment.api_url}`+'/leads',
            { params: httpParams }
        );
    }

    getProcessedLeads(params: { page?: number; sortBy?: string; sortDir?: string } = {}) {
        const httpParams = this.buildLeadParams(params);
        return this.http.get<Array<Object>>(
            `${environment.api_url}`+'/leads/processed',
            { params: httpParams }
        );
    }

    getDeletedLeads(params: { page?: number; sortBy?: string; sortDir?: string } = {}) {
        const httpParams = this.buildLeadParams(params);
        return this.http.get<Array<Object>>(
            `${environment.api_url}`+'/leads/deleted',
            { params: httpParams }
        );
    }

    deleteLead(uuid: string, isFrontend: boolean = true) {
        return this.http.post<Array<Object>>(
            `${environment.api_url}`+'/lead/delete',
            { UUID: uuid, is_frontend: isFrontend }
        );
    }

    callLead(lead: { phone?: string; first_name?: string; last_name?: string; email?: string }) {
        return this.http.post<any>(
            `${environment.api_url}`+'/lead/call',
            {
                phone: lead.phone,
                first_name: lead.first_name,
                last_name: lead.last_name,
                email: lead.email,
            }
        );
    }

    attachOpportunity(payload: {
        lead_uuid: string;
        entity_idx: number;
        object_idx: number;
        phone?: string;
        email?: string;
    }) {
        return this.http.post<any>(
            `${environment.api_url}`+'/lead/attach-opportunity',
            payload
        );
    }

    notifyLeadsChanged(): void {
        this.leadsChangedSubject.next();
    }

    private buildLeadParams(params: { page?: number; sortBy?: string; sortDir?: string }): HttpParams {
        let httpParams = new HttpParams();

        if (params.page) {
            httpParams = httpParams.set('page', params.page.toString());
        }

        if (params.sortBy) {
            httpParams = httpParams.set('sort_by', params.sortBy);
        }

        if (params.sortDir) {
            httpParams = httpParams.set('sort_dir', params.sortDir);
        }

        return httpParams;
    }
}
